import type { Sport } from '__generated__/globalTypes';
import { INVITE } from 'constants/__generated__/routes';
import { useSportContext } from 'contexts/sport';

export const useInviteLink = (sport?: Sport) => {
  const { generateSportContextPath, sport: currentSport } = useSportContext();

  return generateSportContextPath(INVITE, {
    sport: sport || currentSport,
  });
};
